import { Box, SimpleGrid, Text } from "@chakra-ui/react";
import type React from "react";
import FaceliftText from "@/components/Atoms/FaceliftText";

export type PopupFieldValue = string | number | React.ReactNode;

export type PopupField = {
  label: string;               // e.g. "Provider"
  value: PopupFieldValue;      // string OR <Component />
  isEmpty?: boolean;           // optional (for custom empty handling)
  link?: string;              // optional URL for clickable values
};

export function PopupDetailsGrid({
  fields,
  columns = { base: 1, md: 3 },
  gap = 10,
  emptyText = "",
}: {
  fields: PopupField[];
  columns?: any; // Chakra responsive value (or use ResponsiveValue<number>)
  gap?: number;
  emptyText?: string;
}) {
  return (
    <SimpleGrid columns={columns} gap={gap}>
      {fields.map((f, ind) => {
        const showEmpty =
          f.isEmpty ||
          f.value === null ||
          f.value === undefined ||
          (typeof f.value === "string" && f.value.trim() === "");

        return (
          <Box key={ind + 1}>
            <FaceliftText fontSize="xs" color="gray.500">
              {f.label}
            </FaceliftText>

            <Box mt="1" fontWeight="500">
              {showEmpty ? (
                <FaceliftText color="gray.400" fontSize={'2xs'}>
                  {emptyText}
                </FaceliftText>
              ) : f.link ? (
                <a href={f.link} target="_blank" rel="noopener noreferrer">
                  <FaceliftText fontSize={'xs'} color="green" textDecoration="underline">
                    {f.value}
                  </FaceliftText>
                </a>
              ) : (
                <FaceliftText fontSize={'xs'}>{f.value}</FaceliftText>
              )}
            </Box>
          </Box>
        );
      })}
    </SimpleGrid>
  );
}
